import React, { useEffect, useState } from "react";
import axios from "axios";
import { getToken } from "../../services/authService";
import { BASE_URL } from "../../config.json";
import { useHistory } from "react-router-dom";
import CustomLoader from "../Reusable/CustomLoader";

const AllClubCourses = () => {
  const [clubs, setClubs] = useState([]);
  const [clubCourses, setClubCourses] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
const [loading, setLoading] = useState(true);

  const token = getToken();
  const history = useHistory();

  useEffect(() => {
    fetchClubs();
  }, []);

  useEffect(() => {
    const filteredClubs = clubs.filter((club) =>
      club.club_name.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setTotalPages(Math.ceil(filteredClubs.length / itemsPerPage));

    if (filteredClubs.length > 0) {
      const currentFiltered = filteredClubs.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
      );
      fetchCoursesForClubs(currentFiltered.map((club) => club.id));
    }
  }, [clubs, currentPage, searchTerm]);

  useEffect(() => {
    setCurrentPage(1); // reset to first page on new search
  }, [searchTerm]);

  const fetchClubs = async () => {
    try {
      const res = await axios.get("https://timelygolf.co.uk/club/golf-clubs/");
      setClubs(res.data);
          setLoading(false); // Stop loader if error


    } catch (err) {
      console.error("Failed to fetch club list", err);
          setLoading(false); // Stop loader if error

    }
  };

  const fetchCoursesForClubs = async (clubIds) => {
    const newCourses = { ...clubCourses };
    await Promise.all(
      clubIds.map(async (clubId) => {
        if (!newCourses[clubId]) {
          try {
            const res = await axios.get(
              `${BASE_URL}/club/golfclub/${clubId}/courses/`,
              {
                headers: { Authorization: `Bearer ${token}` },
              }
            );
            newCourses[clubId] = res.data;
          } catch (err) {
            newCourses[clubId] = "Error";
            console.error(`Failed to fetch courses for club ${clubId}`, err);
          }
        }
      })
    );
    setClubCourses(newCourses);
  };

  const handleClubClick = (clubId) => {
    localStorage.setItem("selected_club_id", clubId);
    history.push("/club-course-list");
  };

  const filteredClubs = clubs.filter((club) =>
    club.club_name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentClubs = filteredClubs.slice(indexOfFirstItem, indexOfLastItem);

  return (
    <section className="club_Login" style={{ fontFamily: "'Jost', sans-serif" }}>
      <div className="page-width">
        <div className="acchome-block gap-block-section">
          {loading ? (
          <div style={{ display: "flex", justifyContent: "center", padding: "3rem" }}>
            <CustomLoader type="spinner-cub" color="#B4C227" size={100} />
          </div>
        ) : 
         ( <div className="acccore__wrap" style={{ width: "90%", margin: "3rem 20% 3rem" }}>
            {/* Search Bar */}
            <div style={{ marginBottom: "20px", textAlign: "start" }}>
              <input
                type="text"
                placeholder="Search clubs..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                style={{
                  padding: "10px",
                  width: "300px",
                  borderRadius: "4px",
                  border: "1px solid #ccc",
                  fontSize: "16px",
                }}
              />
            </div>

            {/* Club Table */}
            <table className="club-table" style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead>
                <tr style={{ backgroundColor: "#13320c", color: "white" }}>
                  <th style={thStyle}>Club ID</th>
                  <th style={thStyle}>Club Name</th>
                  <th style={thStyle}>Club Courses</th>
                  <th style={thStyle}>Actions</th>
                </tr>
              </thead>
              <tbody>
                {currentClubs.map((club) => (
                  <tr key={club.id}>
                    <td style={tdStyle}>{club.id}</td>
                    <td style={tdStyle}>{club.club_name}</td>
                    <td style={tdStyle}>
                      {clubCourses[club.id] === "Error"
                        ? "Failed to load courses"
                        : clubCourses[club.id]?.data
                        ? clubCourses[club.id].data.map((course, idx) => (
                            <div key={idx}>{course.course_name}</div>
                          ))
                        : "Loading..."}
                    </td>
                    <td style={tdStyle}>
                      <button
                        className="res-btn-primary small-width"
                        style={{ display: "block", margin: "0 auto", width: "80px" }}
                        onClick={() => handleClubClick(club.id)}
                      >
                        View
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            {/* Pagination */}
            <div style={{ marginTop: "20px", textAlign: "center" }}>
              <button
                onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                disabled={currentPage === 1}
                style={buttonStyle}
              >
                Prev
              </button>

              {Array.from({ length: totalPages }, (_, i) => i + 1)
                .filter(
                  (pageNum) =>
                    pageNum === 1 ||
                    pageNum === totalPages ||
                    (pageNum >= currentPage - 2 && pageNum <= currentPage + 2)
                )
                .map((page, i, arr) => (
                  <React.Fragment key={page}>
                    {i > 0 && page - arr[i - 1] > 1 && <span>...</span>}
                    <button
                      onClick={() => setCurrentPage(page)}
                      style={{
                        ...buttonStyle,
                        backgroundColor: currentPage === page ? "#007bff" : "#e0e0e0",
                        color: currentPage === page ? "#fff" : "#000",
                      }}
                    >
                      {page}
                    </button>
                  </React.Fragment>
                ))}

              <button
                onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
                disabled={currentPage === totalPages}
                style={buttonStyle}
              >
                Next
              </button>
            </div>
          </div>)}
        </div>
      </div>
    </section>
  );
};

const tdStyle = {
  padding: "10px",
  border: "1px solid #ddd",
  textAlign: "center",
  verticalAlign: "middle",
};

const thStyle = {
  ...tdStyle,
  fontWeight: "bold",
};

const buttonStyle = {
  margin: "0 5px",
  padding: "5px 10px",
  backgroundColor: "#e0e0e0",
  borderRadius: "4px",
  cursor: "pointer",
};

export default AllClubCourses;
